import { TeamMember, MemberTask } from '@/types/team';
import { TeamService } from '@/services/teamService';

export class TeamModel {
  // Delegate all operations to TeamService
  static async createTeamMember(member: Partial<TeamMember>) {
    return TeamService.createTeamMember(member);
  }

  static async getTeamMembers(): Promise<TeamMember[]> {
    return TeamService.getTeamMembers();
  }

  static async updateTeamMember(id: string, memberData: TeamMember): Promise<TeamMember> {
    return TeamService.updateTeamMember(id, memberData);
  }

  static async deleteTeamMember(id: string): Promise<void> {
    return TeamService.deleteTeamMember(id);
  }

  static async findTeamMemberByEmail(email: string): Promise<TeamMember | null> {
    return TeamService.findTeamMemberByEmail(email);
  }

  // Member task operations - These would need to be implemented if tasks are needed
  static async assignTaskToMember(memberId: string, task: MemberTask): Promise<void> {
    console.log('⚠️ Task assignment not implemented yet - would need separate tasks table');
    // TODO: Implement task assignment with proper database table
  }

  static async getMemberTasks(memberId: string): Promise<MemberTask[]> {
    console.log('⚠️ Member tasks not implemented yet - would need separate tasks table');
      return [];
  }

  // Initialize with default admin
  static async initializeDefaultAdmin(): Promise<TeamMember | null> {
    return TeamService.initializeDefaultAdmin();
  }

  // Removed sample data creation methods as we'll use database
  // Development utility: Reset all team data
  static async resetTeamData(): Promise<void> {
    console.log('⚠️ Reset team data not implemented - this would delete all team members from database');
    console.log('If you need to reset data, please do it directly in Supabase dashboard');
  }

  // Development utility: Check if sample data exists
  static hasSampleData(): boolean {
    console.log('⚠️ Sample data check not applicable - using database now');
    return false;
  }

  // Approve team member (now implemented)
  static async approveTeamMember(id: string, approvedById: string): Promise<TeamMember> {
    return await TeamService.approveTeamMember(id, approvedById);
  }

  // Reject team member (now implemented)
  static async rejectTeamMember(id: string, rejectedById: string): Promise<TeamMember> {
    return await TeamService.rejectTeamMember(id, rejectedById);
      }

  // Set member password
  static async setMemberPassword(email: string, password: string): Promise<TeamMember> {
    return await TeamService.setMemberPassword(email, password);
  }
} 